import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

export default function CommonDialog(props) {
  const theme = useTheme();
  const { onClose, open, title } = props;
  const maxWidth = props.maxWidth || "sm";

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      maxWidth={maxWidth}
      onClose={handleClose}
      aria-labelledby="common-dialog-title"
      open={open}
    >
      <DialogTitle
        id="common-dialog-title"
        sx={{
          marginBottom: 2,
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent>{props.render(props)}</DialogContent>
    </Dialog>
  );
}

CommonDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  render: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};
